import React from 'react';
import { Alert } from 'antd';
import { t } from 'i18next';
import { ENGINE_VERSION_1_0 } from '@/store/Engine/constants';
import { VersionAlertContainer } from './styled';

interface VersionAlertProps {
  engineVersion: string;
}

const VersionAlert: React.FC<VersionAlertProps> = ({ engineVersion }) => {
  if (engineVersion !== ENGINE_VERSION_1_0) {
    return null;
  }

  return (
    <VersionAlertContainer>
      <Alert message={t('centrifugalStation1_0Notification')} type="warning" showIcon className="version-alert-box" />
    </VersionAlertContainer>
  );
};

export default VersionAlert;
